import type {CellRendererType} from '../../types/EagColumn';

/** Map column renderer type to a skeleton placeholder class for visual variety.
 *  Shared by the whole-grid SkeletonRow and the per-cell loading state in GridCell,
 *  so both shimmer styles stay pixel-identical. */
export function getSkeletonBarClass(rendererType: CellRendererType | undefined): string {
  switch (rendererType) {
    case 'INTEGER':
    case 'FILE_SIZE':
    case 'MONEY':
    case 'MONEY_NO_DECIMAL':
      return 'animate-pulse bg-gray-200 h-4 rounded w-2/3 ml-auto';
    case 'DATE':
    case 'DATE_TIME':
    case 'TIME_INTERVAL':
      return 'animate-pulse bg-gray-200 h-4 rounded w-3/4';
    case 'CHECKBOX':
      return 'animate-pulse bg-gray-200 w-4 h-4 rounded-sm mx-auto';
    case 'TAG':
    case 'FLAG':
      return 'animate-pulse bg-gray-200 w-1/2 h-5 rounded-full';
    default:
      return 'animate-pulse bg-gray-200 h-4 rounded w-full';
  }
}
